import { Grid, Button, TextField, Typography, MenuItem, Box, Card, CardContent } from '@mui/material';
import React, { useState } from 'react';
import { motion } from 'framer-motion';

const Expertsolution = () => {
  const [college, setCollege] = useState("");

  const handleCollegeChange = (event) => {
    setCollege(event.target.value);
  };

  return (
    <Box sx={{ background: 'var(--background-light)', padding: { xs: 4, md: 10 } }}>
      <Grid container spacing={6} alignItems="center" maxWidth="1200px" mx="auto">
        {/* Left Section */}
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Typography
              variant="h3"
              sx={{
                mb: 3,
                fontSize: { xs: '32px', sm: '40px', md: '48px' },
                fontWeight: 800,
                color: 'var(--primary-dark)',
                lineHeight: 1.2
              }}
            >
              If you’re Confused?<br />
              <span style={{ color: 'var(--primary-color)' }}>Don’t worry! We will Help You</span>
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '16px', md: '18px' },
                color: 'var(--text-secondary)',
                lineHeight: 1.8,
                maxWidth: '500px'
              }}
            >
              Are you looking for admissions to pursue higher education at a top college, but need guidance? Reach out to our Admission Experts Now and make your dream a reality!
            </Typography>
          </motion.div>
        </Grid>

        {/* Right Section */}
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <Card className="glass-card" sx={{ borderRadius: '24px', p: { xs: 2, md: 4 }, boxShadow: '0 20px 40px rgba(0,0,0,0.1)' }}>
              <CardContent>
                <form>
                  <Typography
                    variant="h5"
                    sx={{
                      color: 'var(--primary-dark)',
                      mb: 4,
                      fontWeight: 800,
                      textAlign: 'center',
                    }}
                  >
                    Connect with Our Expert Now!
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        label="Full Name"
                        variant="outlined"
                        fullWidth
                        size="medium"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                            borderRadius: '12px'
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Phone Number"
                        variant="outlined"
                        fullWidth
                        size="medium"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                            borderRadius: '12px'
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        select
                        label="Select College"
                        value={college}
                        onChange={handleCollegeChange}
                        fullWidth
                        variant="outlined"
                        size="medium"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                            borderRadius: '12px'
                          }
                        }}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              style: {
                                maxHeight: 200,
                              },
                            },
                          },
                        }}
                      >
                        <MenuItem value="St. Josephs Pre-Universtiy College">St. Josephs Pre-Universtiy College</MenuItem>
                        <MenuItem value="Christ Junior College">Christ Junior College</MenuItem>
                        <MenuItem value="RV Pre-University College">RV Pre-University College</MenuItem>
                        <MenuItem value="Jyothy KV PU College">Jyothy KV PU College</MenuItem>
                        <MenuItem value="Amc College">Amc College</MenuItem>
                        <MenuItem value="National College, Basavanagudi">National College, Basavanagudi</MenuItem>
                        <MenuItem value="Vivekananda PU College">Vivekananda PU College</MenuItem>
                        <MenuItem value="Bgs International Residential Independent PU College">Bgs International Residential Independent PU College</MenuItem>
                        <MenuItem value="SEA Composite PU College">SEA Composite PU College</MenuItem>
                        <MenuItem value="Bishop Cotton Women's College">Bishop Cotton Women's College</MenuItem>
                        <MenuItem value="M. S. Ramaiah Pre-University College">M. S. Ramaiah Pre-University College</MenuItem>
                        <MenuItem value="Sree Chaitanya Junior College">Sree Chaitanya Junior College</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Message"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={3}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                            borderRadius: '12px'
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        sx={{
                          background: 'var(--primary-color)',
                          color: '#fff',
                          mt: 2,
                          py: 1.5,
                          fontSize: '16px',
                          fontWeight: 700,
                          borderRadius: '12px',
                          boxShadow: '0 8px 16px rgba(26, 35, 126, 0.2)',
                          textTransform: 'none',
                          '&:hover': {
                            background: 'var(--secondary-color)',
                            transform: 'translateY(-2px)',
                            boxShadow: '0 12px 20px rgba(233, 30, 99, 0.3)',
                          },
                          transition: 'all 0.3s ease'
                        }}
                        fullWidth
                      >
                        Submit Application
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </motion.div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Expertsolution;
